import { MedicalItem } from "./MedicalItem";

class MedicalItemAlertsAndSpecialNeeds extends MedicalItem {
    public EndDate: Date;
    public Description: string;
    public Name: string;
    public PrecisionEndDate: number;
}

export { MedicalItemAlertsAndSpecialNeeds };
